<div class="portfolio-wrap p-4">
  <div class="portfolio-header d-flex justify-content-between">
    <div class="title">
      <h3 class="text-bold" i18n="@@exchange.balance.title">Portfolio</h3>
      <div class="local-currency-balance">
        {{ total?.currency || defaultFiatCurrency }} {{ total?.amount || 0 | number: "0.2-2" }}
      </div>
      <div class="global-currency-balance" *ngIf="usdTotal?.amount">
        {{ usdTotal?.currency || globalCurrency }} {{ usdTotal?.amount | number: "0.2-2" }}
      </div>
    </div>
    <div class="balance-cancel pt-3">
      <a (click)="onClose($event)" class="cancel"><i class="icon-cancel"></i></a>
    </div>
  </div>
</div>

<div class="summary-pnl-section gap-2 px-4 pb-3" *ngIf="pnlData$ | async as pnlData" >
  <div>
    <div class="label" i18n="@@exchange.balance.subTitle.dailyPnl">
      Today's PnL
    </div>
    <div *ngIf="pnlData?.totalProWallet > 0; else emptyValue" class="value"
         [ngClass]="pnlData?.dailyPnl >= 0 ? 'positive' : 'negative'">
      {{defaultFiatCurrency}}&nbsp;<signed-number [value]="pnlData?.dailyPnl"></signed-number>
      (
      <signed-number [value]="pnlData?.dailyPnl/pnlData?.totalProWallet"></signed-number>
      %)
    </div>
    <ng-template #emptyValue>
      <span>-</span>
    </ng-template>
  </div>
  <div>
    <a class="icon-wrap" (click)="onPnLClick()"><i class="icon icon-metrics"></i></a>
  </div>
</div>

<div class="site-list-wrap px-4 pb-3">
  <div *ngIf="fiatData?.length" class="fiat-wrap">
    <div i18n="@@exchange.balance.subTitle.fiat">Fiat Wallets</div>
    <div class="site-list with-img pb-4">
      <ng-container *ngTemplateOutlet="fiatItem; context: { $implicit: fiatData }"></ng-container>
    </div>
  </div>
  <div *ngIf="cryptoData?.length" class="crypto-wrap">
    <div i18n="@@exchange.balance.subTitle.crypto">Wallet</div>
    <div class="site-list with-img">
      <ng-container *ngTemplateOutlet="cryptoItem; context: { $implicit: cryptoData }"></ng-container>
    </div>
  </div>
</div>

<ng-template #fiatItem let-data>
  <div *ngFor="let balance of data" class="list-item">
    <div class="list-item-img">
      <currency class="md" [currency]="balance?.currency?.code"></currency>
    </div>
    <div class="list-item-content">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="title">{{ balance?.currency?.code }}</div>
          <div class="text text-sm sub-text">{{ balance?.currency?.name }}</div>
        </div>
        <div class="text-end">
          <div class="text text-bold">
            {{ balance?.currency?.code }}
            {{ balance?.balance?.amount.amount || 0 | number: "1.2-2" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cryptoItem let-data>
  <div *ngFor="let balance of data" class="list-item">
    <div class="list-item-img">
      <currency class="md" [currency]="balance?.currency?.code"></currency>
    </div>
    <div class="list-item-content">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="title">
            {{ balance?.currency?.code }}
            {{ balance?.balance?.amount?.amount || 0 | number: "1.2-8" }}
          </div>
          <div class="text text-sm sub-text">
            {{ balance?.currency?.name }}
          </div>
        </div>
        <div class="text-end">
          <div class="text text-bold">
            {{ balance?.balance?.value?.currency }}
            {{ balance?.balance?.value?.amount || 0 | number: "1.2-8" }}
          </div>
          <div *ngIf="
              balance?.balance?.usdValue?.currency !==
              balance?.balance?.amount?.currency
            " class="text text-sm sub-text">
            {{ balance?.balance?.usdValue?.currency || globalCurrency }}
            {{ balance?.balance?.usdValue?.amount || 0 | number: "1.2-8" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
